import React, {useState} from "react"

import FieldTimeReported_CustomTime from "./components/custom-time"
import StartEndTime from "./components/start-end-time"
import MinutesPreset from "./components/minutes-preset"
import HoursPreset from "./components/hours-preset"
import FieldPopover_InlineEditable from "../../../../popover/render/inline-editable"
import FieldPopover_FormComponent from "../../../../popover/components/form/form-component"
import FieldTimeReported_PopoverIsBillable from "./components/is-billable"
import FieldTimeSpent from "../../time-spent"
import HelpButton from "../../../../../../gd-components/buttons/help-button/help-button"

type Props = {
    parent          : FieldPopover_FormComponent | FieldPopover_InlineEditable
    field           : FieldTimeSpent
    model?          : any
    options?        : any
    configOptions?  : any
    hideIsBillable? : boolean
}

export default function FieldTimeSpent_PopoverContent(props: Props) {
    const field = props.field
    const [labelHovered, setLabelHovered] = useState(false)

    const onPresetClick = (value: number) => {
        props.parent.onValueChange(value, true)
    }

    const displayStartEnd = _.get(props.options, 'displayStartEnd', true) && field.hasStartEnd
    const popoverLabel    = _.get(props.configOptions, 'popoverLabel', null) as string | null
    const popoverHint     = _.get(props.configOptions, 'popoverHint',  null) as string | null
    const showIsBillable  = gd.modules.timeTracking.isBillableTimeEnabled && field.canBeBillable && !props.hideIsBillable
    const showHintButton  = labelHovered && popoverHint

    return (
        <div className="wrapper">
            <div className="content p-15">

                {popoverLabel &&
                    <div className      = "flex-row-left-center m-b-10 h-20"
                         onMouseEnter   = {() => setLabelHovered(true)}
                         onMouseLeave   = {() => setLabelHovered(false)}
                    >
                        <div className="ui5-txt-no-accent-tiny">{popoverLabel}</div>
                        {showHintButton &&
                            <HelpButton
                                className   = "m-l-5"
                                type        = "v2"
                                hint        = {popoverHint}
                            />
                        }
                    </div>
                }

                <FieldTimeReported_CustomTime
                    parent  = {props.parent}
                    model   = {props.model}
                    field   = {field}
                />

                {displayStartEnd &&
                    <StartEndTime
                        parent  = {props.parent}
                        model   = {props.model}
                    />
                }

                <div className="m-t-20">
                    <MinutesPreset
                        field       = {field}
                        onSubmit    = {onPresetClick}
                    />
                    <HoursPreset
                        field       = {field}
                        onSubmit    = {onPresetClick}
                    />
                </div>

                {showIsBillable &&
                    <FieldTimeReported_PopoverIsBillable
                        parent  = {props.parent}
                        model   = {props.model}
                    />
                }
            </div>
        </div>
    )
}
